import type { Questionnaire } from "@/models/questionnaire";
import type ReceivedQuestionnaires from "@/models/receivedQuestionnaires";
import type ReceivedQuestionnaire from "@/models/receivedQuestionnaire";
import axios from "axios";

export const getQuestionnaires = async (): Promise<Questionnaire[]> => {
  const resp = await axios.get<Questionnaire[]>("/api/questionnaires");
  return resp.data;
};

export const getReceivedQuestionnaires =
  async (): Promise<ReceivedQuestionnaires> => {
    const resp = await axios.get<ReceivedQuestionnaires>(
      "/api/questionnaires/received"
    );
    return resp.data;
  };

export const getSenderCompanies = async (): Promise<string[]> => {
  const resp = await axios.get("/api/questionnaires/sender-companies");
  return resp.data;
};

export const getCompletedReceivedQuestionnairesForTemplateId = async (
  templateId: string
): Promise<ReceivedQuestionnaire[]> => {
  const resp = await axios.get("/api/questionnaires/completed", {
    params: { templateId },
  });
  return resp.data;
};
